import shop from "shop/shop"

export const loadState = ( setState, url, ready = true, opts = {} ) => {
  return () => {
    async function load() {
      try {
        const data = await shop.fetch( url, opts )
        setState( data )
      } catch (err) {
        console.error( err )
      }
    }
    
    ready && load()
  }
}


// WEBPACK FOOTER //
// ./src/sdk/util/loadState.js